import React from 'react'
import { FaFacebookF, FaInstagram } from 'react-icons/fa'; // Added FaInstagram
import { BiLogoLinkedin } from 'react-icons/bi';
import './Card.css'
function Card(props) {
    return (
        <>


            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                <div className="our-team">
                    <div className="picture">
                        <img className="img-fluid" src={props.ImageUrl} alt="" />
                    </div>
                    <div className="team-content">
                        <h3 className="name">{props.name}</h3>
                        {Array(3).fill().map((_, idx) => (
                            <h4
                                className={`title${Array.isArray(props.position)
                                    ? (props.position[idx] ? '' : ' placeholder-title')
                                    : (idx === 0 ? '' : ' placeholder-title')}`}
                                key={idx}
                            >
                                {Array.isArray(props.position)
                                    ? (props.position[idx] || '')
                                    : (idx === 0 ? props.position : '')}
                            </h4>
                        ))}
                    </div>
                    <ul className="social">
                        <li>
                            <a href={props.facebookLink} target='_blank' rel="noreferrer" aria-hidden="true">
                                <FaFacebookF />
                            </a>
                        </li>
                        <li>
                            <a href={props.linkedinLink} target='_blank' rel="noreferrer" aria-hidden="true">
                                <BiLogoLinkedin />
                            </a>
                        </li>
                        {props.InstagramLink ? (
                            <li>
                                <a
                                    href={props.InstagramLink}
                                    target='_blank'
                                    rel="noreferrer"
                                    aria-hidden="true"
                                >
                                    <FaInstagram />
                                </a>
                            </li>
                        ) : null}
                    </ul>
                </div>
            </div>



        </>
    )
}

export default Card